export default __webpack_public_path__ + "static/media/doctor-2.e371e50e.png";